import { Component, Input, OnInit } from '@angular/core';
import { AdBannerService } from '../_services/ad-banner.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-ad-content',
    templateUrl: './ad-content.component.html',
    styleUrls: ['./ad-content.component.css'],
    standalone: false
})
export class AdContentComponent implements OnInit {
    @Input() adImageOne: string = '';
    @Input() adLinkOne: string = '';
    @Input() adImageTwo: string = '';
    @Input() adLinkTwo: string = '';
    @Input() bannerGroup: string = '';

    dynamicBanners: { image: string; url: string }[] = [];

    constructor(private adBannerService: AdBannerService) {}

    ngOnInit(): void {
        if (this.bannerGroup) {
            this.adBannerService.loadByGroup(this.bannerGroup).subscribe(banners => {
                this.dynamicBanners = banners.map(b => ({
                    image: environment.image_cdn_url + '/' + b.imagePath,
                    url: b.url || ''
                }));
            });
        }
    }
}
